var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('div',{staticClass:"hp-bg-color-dark-90 min-vh-100 d-flex"},[_c('div',{staticClass:"hp-main-layout hp-main-layout-horizontal"},[_c('header-horizontal'),_c('div',{staticClass:"hp-main-layout-content"},[_c('vue-page-transition',{attrs:{"name":"fade-in-up"}},[_c('router-view')],1)],1),_c('app-footer')],1)]),_c('scroll-to-top')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }